import React from 'react';

const FireAnimation = () => {
  return (
    <div className="w-200 h-200">
      <img 
        src="https://cdn.spookytools.com/assets/spooks%20a%20glasses.png"
        alt="Fire"
        className="w-full h-full absolute animate-pulse"
        style={{
          animation: 'flicker 3s infinite',
          filter: 'drop-shadow(0 0 10px rgba(255, 0, 255, 0.5))'
        }}
      />
      <div className="absolute inset-0 animate-pulse" 
        style={{
          animation: 'glow 2s ease-in-out infinite alternate',
          background: 'radial-gradient(circle, rgba(238,174,202,0) 0%, rgba(148,187,233,0) 100%)'
        }}
      />
      <style jsx>{`
          @keyframes flicker {
            0% { transform: translateY(0px) scale(2); }
            50% { transform: translateY(-10px) scale(2); }
            100% { transform: translateY(0px) scale(2); }
          }
        `}</style>
    </div>
  );
};

export default FireAnimation;